import { useEffect } from "react"

import { useLazyGetContractorAccountStatusesQuery } from "store/api/dictionaryApi"
import { useAppDispatch, useAppSelector } from "store/hooks"
import { setContractorAccountStatusOptions } from "store/tempDataSlise"
import { UITypes } from "types"

import { checkRoleType } from "utils/checkRoleType"

export const useLoadContractorAccountStatuses = () => {
  const dispatch = useAppDispatch()
  const isUserAuthorized = useAppSelector(state => state.user.isUserAuthorized)
  const userProfile = useAppSelector(state => state.user.userProfile)
  const [triggerGetContractorAccountStatuses] = useLazyGetContractorAccountStatusesQuery()
  const userRole = checkRoleType(userProfile?.type)

  useEffect(() => {
    const loadContractorAccountStatuses = async () => {
      if ((userRole === "vendor-admin" || userRole === "sales-manager") && isUserAuthorized) {
        try {
          const res = await triggerGetContractorAccountStatuses()
          if (res?.data?.data) {
            const options: UITypes.Option[] = res.data.data.map(item => ({
              label: item.name,
              value: String(item.id),
              color: item.fe_color,
            }))
            dispatch(setContractorAccountStatusOptions(options))
          }
        } catch (error) {
          console.error("Failed to load contractor account statuses:", error)
        }
      }
    }

    loadContractorAccountStatuses()
  }, [userRole, isUserAuthorized, triggerGetContractorAccountStatuses, dispatch])
}
